import { useFlow } from '@router/stackflow';
import { useActivity } from '@stackflow/react';

function useGoBack() {
    const { pop } = useFlow();
    const { isRoot } = useActivity();

    return () => {
        if (isRoot) {
            window.history.go(-1);
        } else {
            pop();
        }
    };
}

export default useGoBack;
